/* eslint-disable @typescript-eslint/no-floating-promises */
import { APIURL } from "../react/config";
import superagent from 'superagent';





export async function httpRequest(
endpoint,
fields,
headers,
file)
{
  return new Promise((resolve, reject) => {
    const req = superagent.post(`${APIURL}${endpoint}`);

    Object.keys(headers).forEach((headerKey) => {
      req.set(headerKey, headers[headerKey]);
    });

    Object.keys(fields).forEach((fieldKey) => {
      req.field(fieldKey, fields[fieldKey]);
    });

    if (file) {
      req.attach('file', file, file.name);
    }

    req.
    on('response', (response) => {
      const data = JSON.parse(response.text);
      if (response.status === 200) {
        resolve(data);
      } else {
        reject(data);
      }
    }).
    end();
  });
}